import Toash from "./components/toash";

class Anchor {
  constructor() {
    this.anchorEls = document.querySelectorAll(".jsAnchor");
    this.top = 100;
    this.init();
  }

  init() {
    if (this.anchorEls.length > 0) {
      this.anchorEls.forEach((anchorEl) => {
        anchorEl.addEventListener(
          "click",
          this.anchorClick.bind(this, anchorEl)
        );
      });
    }
    this.hash = window.location.hash;
    if (this.hash) {
      let anchorTargetEl = document.getElementById(this.hash.replace("#", ""));
      this.move(anchorTargetEl, "init");
    }
  }

  move(el, state) {
    if (state === "init") {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        0
      );
    }
    $("html, body").animate(
      {
        scrollTop: el.offsetTop - this.top,
      },
      500
    );
  }

  anchorClick(el, e) {
    let anchorTargetEl = document.getElementById(el.dataset.anchor);
    if (anchorTargetEl) {
      this.move(anchorTargetEl, "click");
      e.preventDefault();
    }
  }
}

class SendEmail {
  constructor() {
    this.btnSubmitEl = document.getElementById("jsSubmit");
    this.nameEl = document.getElementById("jsName");
    this.telEl = document.getElementById("jsTel");
    this.emailEl = document.getElementById("jsEmail");
    this.msgEl = document.getElementById("jsMsg");
    this.txtEl = document.getElementById("jsTxt");
    this.regexEmail =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    this.toash = new Toash("jsToash");
    this.init();
  }

  init() {
    if (this.btnSubmitEl) {
      this.btnSubmitEl.addEventListener("click", (e) => {
        this.txtEl.innerHTML = "";
        if (
          this.nameEl.value === "" ||
          this.emailEl.value === "" ||
          this.telEl.value === "" ||
          this.msgEl.value === ""
        ) {
          this.toash.show("Vui lòng điền đầy đủ thông tin!", "error");
        } else if (!this.emailEl.value.match(this.regexEmail)) {
          this.toash.show("Email không đúng định dạng!", "error");
        } else {
          this.btnSubmitEl.dataset.state = "sending";
          this.send();
        }
        e.preventDefault();
      });
    }
  }

  send() {
    let url = "https://email-service.htemplate.com/Email",
    data = {
      name: this.nameEl.value,
      tel: this.telEl.value,
      email: this.emailEl.value,
      msg: this.msgEl.value,
      from: "dangkylapdatinternet.com@gmail.com",
      app: "fgra bbcd owpz twhh",
      to: "tuyenttt8fptcto@gmail.com",
    },
    options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(url, options)
      .then((data) => {
        this.nameEl.value = "";
        this.emailEl.value = "";
        this.msgEl.value = "";
        this.telEl.value = "";
        this.toash.show("Gửi email thành công!", "success");
        this.txtEl.innerHTML = "Cảm ơn bạn đã gửi liên hệ, chúng tôi sẽ liên hệ bạn trong thời gian sớm nhất!";
        this.btnSubmitEl.dataset.state = "success";
      })
      .catch((error) => {
        console.error("Error:", error);
        this.btnSubmitEl.dataset.state = "error";
      });
  }
}

window.addEventListener("load", (e) => {
  new Anchor();
  new SendEmail();
});